import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { ValidateAPI } from '../../utils/Utils'
import { useNavigate } from 'react-router-dom'
import { Navigate } from 'react-router-dom'
import Loading from '../Loading'
import { CommonAPICall } from '../../CommonAPiContext/context'
import { useTranslation } from 'react-i18next'
import axiosInstance from '../../api/axiosInstance'

const VendorCRage = ({ vendor, cpiOffice, vendorName, supplierId, chartsData }) => {
  const user = JSON.parse(localStorage?.getItem('userData'))
  const navigate = useNavigate()
  const [tableData, setTableData] = useState([])
  const [columns, setColumns] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [selectedBuyer, setSelectedBuyer] = useState('')
  const [selectedVendor, setSelectedVendor] = useState('')
  const [selectSku, setSelectSku] = useState('')
  const { addFilterData } = CommonAPICall()
  const { t } = useTranslation()
  const { CRAging,Norelateddatafound } = t('vendorcrpage')
  
  const fetchTableData = () => {
    
    const vendorURL = `/api/admin/get-cr-ageing-counts?vendorNumber=${supplierId}`
    if ((vendor && cpiOffice) || supplierId) {
      setLoading(true)
      axiosInstance
        .get(vendorURL)
      .then((response) => {
        const data = response.data
        setTableData(data)

        if (data.length > 0) {
          // Extract column names dynamically from the first object
          const dynamicColumns = Object.keys(data[0])
          setColumns(dynamicColumns)
        }

        setLoading(false)
      })
      .catch((err) => {
        setError('Error fetching data')
        setLoading(false)
      })
    }
  }

  useEffect(() =>{
    if(chartsData && chartsData?.crAging){
      const dynamicColumns = Object.keys(chartsData?.crAging[0])
      setTableData(chartsData?.crAging  || [])
      setColumns(dynamicColumns)
    }
  },[chartsData])

  const handleHeaderClick = (col, row) => {
    const selectedMetric = col === 'RECONFIRM'
    ? 'ReConfirm'
    : col.charAt(0).toUpperCase() + col.slice(1).toLowerCase();
    //getting 0-2 Days need to split number by 0 and 2
    const selectedValue = row?.includes('7')
      ? [7, '']
      : row?.split(' ')[0]?.split('-')
    addFilterData({
      hftUserId: user?.hftOracleId || user?.supplierId,
      tableName: 'VendorChangeReqTable',
      clFilter: []
    })
   
    if (user?.userGroupName === 'OVERSEAS_ROLE') {
      addFilterData({
        hftUserId: user?.hftOracleId,
        tableName: 'NewPoList',
        clFilters: []
      })
      setTimeout(() => {
        addFilterData({
          hftUserId: user?.hftOracleId,
          tableName: 'NewPoList',
          buyerName: {},
          vendorName: vendor ? { "id": vendor, "value": vendorName } : {},
          sku: {},
          clFilter: [
            {
              column: 'ACTION TYPE',
              values: [selectedMetric]
            },

            {
              column: 'SUPPLIER RESPONSE',
              values: ['Awaiting Response']
            },

          ]
        })
        const clFilter = [
          {
            id: 'ACTION TYPE',
            value: selectedMetric
          },
          {
            id: 'CR_AGE',
            value: [selectedValue[0], selectedValue[1]]
          },
          {
            id: 'SUPPLIER RESPONSE',
            value: 'Awaiting Response'
          }
        ]
        navigate(`/buyer/po_list`, { state: clFilter })
      }, 100);
      return

    }
    setTimeout(() => {
      addFilterData({
        hftUserId: user?.supplierId,
        tableName: 'VendorChangeReqTable',
        clFilter: [
          {
            column: 'REQUEST TYPE',
            values: [selectedMetric]
          },
          {
            column: 'status',
            values: ['OPEN']
          },
          {
            column: 'supplier_response',
            values: ['Awaiting Response']
          }
        ]
      })
      const clFilter = [
        {
          id: 'REQUEST TYPE',
          value: selectedMetric
        },
        {
          id: 'crAge',
          value: [selectedValue[0], selectedValue[1]]
        },
        {
          id: 'status',
          value: 'OPEN'
        },
        {
          id: 'supplier_response',
          value: 'Awaiting Response'
        }
      ]
      navigate(`/vendor/po_change_requests`, { state: clFilter })
    }, 100);
  }

  useEffect(() => {
    if(user?.userGroupName === 'SUPPLIER')
    fetchTableData()
  }, [vendor])



  return (
    <div className="w-full overflow-x-auto flex justify-center items-center flex-col gap-4 shadow-lg rounded-md border border-gray-300 p-3 max-h-[360px]">
      <p className="text-md font-medium">{CRAging}</p>

      {loading ? (
        <Loading />
      ) : (
        <>
        {tableData?.length > 0 ? 
        <table className='table-auto border-collapse border border-gray-300 w-full rounded-lg '>

          <thead>
            <tr>
              {columns
                .filter((col) => col !== "DELAY")
                .map((col, index) => (
                  <th
                    key={index}
                    className='border border-gray-300 p-2 font-medium'
                    style={{ minWidth: '150px', maxWidth: '200px' }}
                  >
                    {col}
                  </th>
                ))}
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns
                  .filter((col) => col !== "DELAY")
                  .map((col, colIndex) => {
                    let cellClass = 'border border-gray-300 p-2 text-center'

                    cellClass +=
                      row.DAYS === '3-6 days' && col === 'DAYS'
                        ? ' bg-yellow-500'
                        : row.DAYS === '>=7 days' && col === 'DAYS'
                          ? ' bg-red-500'
                          : ''

                    // cellClass +=
                    //   col !== 'DAYS'
                    //     ? user?.userGroupName !== 'OVERSEAS_ROLE'
                    //       ? ' text-blue-500 underline cursor-pointer'
                    //       : ' text-black'
                    //     : ''
                    if (col !== 'DAYS') {
                      cellClass += " text-blue-500 underline cursor-pointer"
                    }

                    const cellContent =
                      col !== 'DAYS' ? (
                        <span
                          onClick={() => handleHeaderClick(col, row.DAYS)}
                          className='cursor-pointer'
                        >
                          {row[col]}
                        </span>
                      ) : (
                        row[col]
                      )

                    return (
                      <td key={colIndex} className={cellClass}>
                        {cellContent}
                      </td>
                    )
                  })}
              </tr>
            ))}
          </tbody>
        </table>
              : <div className="flex items-center justify-center w-full h-180">
                <p className="text-m font ">{Norelateddatafound}</p>
              </div>
            }
          </>
      )}
    </div>
  )
}

export default VendorCRage
